// Balance the visible area of wordmarks and compact logos without stretching.
// Normalized assets have intentional vertical padding around compact marks.
// Area alone cannot account for lettering versus an icon-and-text lockup.
// These small optical corrections were reviewed together at event-card size.
const OPTICAL_SCALE = { noom: 0.88, toyota: 1.08 };
const LOGO_SELECTOR = '.ds-event-card__brand-logo, .ds-testimonial__logo, .ds-review-card__company-logo';

export function brandLogoHeight(width, height, normalized = false, name = '') {
  if (!(width > 0 && height > 0)) return 16;
  const ratio = width / height;
  const inkFraction = normalized ? (ratio >= 3 ? 1 : ratio >= 1.3125 ? 0.875 : 34 / 48) : 1;
  const targetArea = 768;
  const opticalScale = OPTICAL_SCALE[String(name).trim().toLowerCase().replace(/ logo$/, '')] || 1;
  return Math.min(24, 96 / ratio, Math.sqrt(targetArea / (ratio * inkFraction)) * opticalScale);
}

export function initializeBrandLogoSizing(root = document) {
  const sizeLogo = image => {
    if (!image.matches?.(LOGO_SELECTOR) || !image.naturalWidth) return;
    const normalized = (image.currentSrc || image.src).includes('/client-logos/loved-by/');
    image.style.setProperty('--brand-logo-height', `${brandLogoHeight(image.naturalWidth, image.naturalHeight, normalized, image.alt)}px`);
  };

  // Capturing load handles lazy images and cards appended by filtering/pagination.
  root.addEventListener('load', event => sizeLogo(event.target), true);
  const sizeLoaded = () => root.querySelectorAll(LOGO_SELECTOR).forEach(sizeLogo);
  sizeLoaded();
  root.addEventListener('DOMContentLoaded', sizeLoaded, { once: true });
  root.addEventListener('turbolinks:load', sizeLoaded);
}
